module.exports = __webpack_public_path__ + "static/img/media_03.6fbec98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/media_03.png
// module id = 4W8+
// module chunks = 0